import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export var rxSubscriber =
/*@__PURE__*/
function () {
  return typeof Symbol === 'function' ?
  /*@__PURE__*/
  Symbol('rxSubscriber') : '@@rxSubscriber_' +
  /*@__PURE__*/
  Math.random();
}();
export var $$rxSubscriber = rxSubscriber;